module.exports = __webpack_public_path__ + "static/img/image14.b20af11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image14.jpg
// module id = B/ty
// module chunks = 1